var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main-cnt ex-has-btn-btm" },
      [
        _vm.errorMessage
          ? _c("div", { staticClass: "error-message" }, [
              _c("div", { staticClass: "d-flex" }, [
                _c("i", { staticClass: "icon-warning mr-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "errror-txt" }, [
                  _c("p", { staticClass: "fs-14 text-red font600" }, [
                    _vm._v(_vm._s(_vm.$t("error.title")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs-14 text-red font600" }, [
                    _vm._v(_vm._s(_vm.errorMessage))
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(_vm.component, {
          tag: "component",
          attrs: {
            voucherParams: _vm.voucherParams,
            setErrorMessage: _vm.setErrorMessage
          },
          on: {
            voucherSuccess: _vm.voucherSuccess,
            "update:actionHandler": function($event) {
              return _vm.$emit("update:actionHandler", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9a4d686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9a4d686","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Voucher/Add.vue
// module id = null
// module chunks = 